<template>
  <div>
    <div class="out_box pc_table_box">
      <div class="list info-list">
        {{ $t('asset_balance_label') }}
        <span style="display: block;word-break:break-all;white-space: break-spaces;">{{ transBig2number(up.asset) }}</span>
      </div>
      <div class="list info-list">
        {{ $t("assetBalance") }}
        <span style="display: block;word-break:break-all;white-space: break-spaces;">{{ up.priceValue }}</span>
      </div>
      <div class="list info-list">
        {{ $t('wallet_balance_label') }}
        <span style="display: block;word-break:break-all;white-space: break-spaces;">{{ up.price }}</span>
      </div>
      <div class="operate_box list" style="flex: revert; margin-right: 10px;">
        <div class="operate_1" @click="showDialog(0)">{{ $t('transfer_in') }}</div>
        <div class="operate_2" @click="showDialog(1)">{{ $t('transfer_out') }}</div>
      </div>
    </div>
    <div class="mobile_table_box" style="margin-top: 2px">
      <div class="asset_content">
        <div class="asset_box">
          <div class="content">
            <div class="">
              <div class="title left">
                {{ $t("asset_balance_label") }}
              </div>
              <div class="value left">{{ transBig2number(up.asset) }}</div>
            </div>
            <div class="">
              <div class="title left">
                {{ $t("wallet_balance_label") }}
              </div>
              <div class="value left">{{ up.price }}</div>
            </div>
            <div class="">
              <div class="title right">
                {{ $t("assetBalance") }}
              </div>
              <div class="value right">{{ up.priceValue }}</div>
            </div>
          </div>
          <span slot="footer" class="dialog_footer_box">
            <el-button class="data_content_button" style="background: #C6FE61;color: #181A20" type="primary"
                       @click="showDialog(0)">{{ $t('transfer_in') }}</el-button>
            <el-button class="cancel_box  data_content_button "
                       @click="showDialog(1)">{{ $t('transfer_out') }}</el-button>
          </span>
        </div>
      </div>
    </div>
    <el-table class="table_box pc_table_box" :data="pageData" style="width: 100%" v-loading="loading"
              element-loading-background="rgba(0, 0, 0, 0.8)" :row-style="{ height: '59px' }"
    >
      <el-table-column prop="coin" :label="$t('currency_name_label')" width="140px"></el-table-column>
      <el-table-column prop="type" :label="$t('type')" >
        <template slot-scope="scope">
          <span v-if="scope.row.type===0" style="color: rgba(46, 189, 133, 1);">{{ $t('transfer_in') }}</span>
          <span v-else style="color: rgba(239, 69, 74, 1);">{{ $t('transfer_out') }}</span>
        </template>

      </el-table-column>
      <el-table-column prop="share" :label="$t('share')" ></el-table-column>
      <el-table-column prop="price2" :label="$t('quantity')" ></el-table-column>
      <el-table-column prop="nextTime" :label="$t('operation_time')"></el-table-column>
      <el-table-column prop="state" :label="$t('status')" align="right"></el-table-column>
      <el-table-column prop="nextTime" :label="$t('action')" align="right">
        <template slot-scope="scope">
          <div class="operate_box" style="justify-content: right;" v-if="scope.row.showOperate">
            <div class="operate_2" style="padding: 0 0;" @click="revert(scope.row)"><span
                style="color: #A5D63F;">{{ $t("revoke") }}</span></div>
          </div>
          <div v-if="!scope.row.showOperate">
            --
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="mobile_table_box mobile_content_c" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="item" v-for="(item,index) in this.pageData">
        <div>
          <div class="title">{{$t('currency_name_label')}}</div>
          <div class="value">{{item.coin}}</div>
        </div>
        <div>
          <div class="title middle">{{$t('share')}}</div>
          <div class="right middle">{{item.share}}</div>
        </div>
        <div>
          <div class="title right">{{$t("type")}}</div>
          <div class="value right">
            <span v-if="item.type===0" style="color: rgba(46, 189, 133, 1);">{{ $t('transfer_in') }}</span>
            <span v-else style="color: rgba(239, 69, 74, 1);">{{ $t('transfer_out') }}</span>
          </div>
        </div>
        <div>
          <div class="title">{{$t('operation_time')}}</div>
          <div class="value">{{item.nextTime}}</div>
        </div>
        <div>
          <div class="title middle">{{$t('quantity')}}</div>
          <div class="value middle">{{item.price2}}</div>
        </div>
        <div>
          <div class="title right">{{$t("action")}}</div>
          <div class="value right cancel">
            <div class="operate_box right" v-if="item.showOperate">
              <span
                  style="color: #A5D63F" @click="revert(item)">{{ $t("revoke") }}</span>
            </div>
            <div v-if="!item.showOperate">
              --
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-pagination @prev-click="prevClick()"
                   @next-click="nextClick()"
                   :page-size="pageSize"
                   align="right"
                   style="margin-bottom: 100px"
                   :current-page.sync="currentPage"
                   layout="prev, pager, next"
                   :total="this.tableData3.length"/>
    <el-dialog :modal="false" :title="inputType==0?$t('transfer_in'):$t('transfer_out')" :visible.sync="dialogVisible">
      <div>
        <div class="dialog_list">
          <div class="left">{{ $t('currency_address_label') }}</div>
          <div class="right">{{ this.up.address }}</div>
        </div>
        <div class="dialog_list">
          <div class="left">{{ $t('currency_name_label') }}</div>
          <div class="right">{{ this.up.name }}</div>
        </div>
        <div class="dialog_list">
          <div class="left">{{ $t('transfer_quantity') }}</div>
          <div class="right">{{ this.num }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog_footer_box2">
        <el-button style="background: #C6FE61;color: #181A20" type="primary"
                   @click="ok1()">{{ $t('confirm') }}</el-button>
        <el-button class="cancel_box" @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :modal="false" :close-on-click-modal="false" :title="inputType==0?$t('transfer_in'):$t('transfer_out')"
               :visible.sync="inputDialog">
      <div v-if="inputType==1" style="color: #EF454AFF;font-weight: 500;margin-bottom: 11px;">
        {{ $t('estimatedTransferableQuantity') }}：{{ canTransOut }}
      </div>
      <div>
        <div class="dialog_list">
          <div class="open-amount-container">
            <input type="number" min="0" class="open-amount-input" v-model="num" value="0">
            <span class="btc-label" @click="max">{{ $t('maximum') }}</span>
          </div>
        </div>

      </div>
      <span slot="footer" class="dialog_footer_box">
        <el-button style="background: #C6FE61;color: #181A20" type="primary"
                   @click="ok2()">{{ $t('confirm') }}</el-button>
        <el-button class="cancel_box" @click="inputDialog = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :modal="false" style="margin-top: 24vh" :show-close="false" :visible.sync="showRevert"
    >
      <div class="text_box">
        {{ $t('confirm_revoke_order') }}
      </div>
      <span slot="footer" class="dialog_footer_box">
        <el-button style="background: #C6FE61;color: #181A20" type="primary"
                   @click="doRevert()">{{ $t("confirm") }}</el-button>
        <el-button class="cancel_box" @click="showRevert = false">{{ $t("cancel") }}</el-button>
      </span>
    </el-dialog>
    <el-drawer :modal="false" direction="btt" custom-class="drawer-bg" :close-on-click-modal="false" :title="inputType==0?$t('transfer_in'):$t('transfer_out')" :visible.sync="showDrawer"
               :with-header="false"
               :append-to-body="true"
               size="225"
    >

      <div class="drawer">
        <div class="minus" @click="showDrawer=false"></div>
        <div class="title">
          <div class="title_c" >{{inputType==0?$t('transfer_in'):$t('transfer_out')}}</div>
          <img class="title_i"  src="../assets/imgs/delete.svg" @click="showDrawer=false"/>
        </div>

        <div v-if="inputType==1" style="color: #EF454AFF;font-weight: 500;margin-bottom: 11px;">
          {{ $t('estimatedTransferableQuantity') }}：{{ canTransOut }}
        </div>
        <div>
          <div class="dialog_list">
            <div class="open-amount-container">
              <input type="number" min="0" class="open-amount-input" v-model="num" value="0">
              <span class="btc-label" @click="max">{{ $t('maximum') }}</span>
            </div>
          </div>

        </div>
        <span slot="footer" class="dialog_footer_box">
        <el-button style="background: #C6FE61;color: #181A20;border-radius: 6px;" type="primary"
                   @click="ok2()">{{ $t('confirm') }}</el-button>
        <el-button class="cancel_box" @click="showDrawer = false">{{ $t('cancel') }}</el-button>
      </span>

      </div>

    </el-drawer>


    <el-drawer :modal="false" direction="btt" :close-on-click-modal="false" :title="inputType==0?$t('transfer_in'):$t('transfer_out')" :visible.sync="showCancel"
               :with-header="false"
               :append-to-body="true"
               size="225"
    >

      <div class="drawer">
        <div class="minus" @click="showDrawer=false"></div>
        <div class="title">
          <div class="title_c" >{{ $t('confirm_revoke_order') }}</div>
          <img class="title_i"  src="../assets/imgs/delete.svg" @click="showDrawer=false"/>
        </div>

        <span slot="footer" class="dialog_footer_box">
        <el-button style="background: #C6FE61;color: #181A20;border-radius: 6px;" type="primary"
                   @click="doRevert()">{{ $t("confirm") }}</el-button>
        <el-button class="cancel_box" @click="showCancel = false">{{ $t("cancel") }}</el-button>
      </span>

      </div>

    </el-drawer>

  </div>


</template>

<script>
import {getTransData} from "../service/queryService";
import {
  createErc20AndSend,
  createLeadingContractAndCall,
  createLeadingContractAndSend,
  estimateAndSend,
  getErc20Info, getGasReward, getSelectTokenInfo
} from "../utils/contract";
import {getAccount, getAccountWithDot, getChainId, isOld, sleep} from "../utils/wallet";
import {Contract, Method, Underling} from "../config/const";
import {isMobile, transBig2number, transNumber2Big, transTime2Date} from "../utils/functions";
import {getLastPrice} from "../service/priceService";
import {ethers} from "ethers";
import config from "../config/config";
import {BigNumber} from "ethers";
import {getDotAddress} from "../utils/strings";
import bigdecimal from "bigdecimal";
import {emmitMessage, MESSAGE} from "../utils/message";

export default {
  name: "activate3",
  props: {
    contractAddress: "",
    token: ""
  },
  data() {
    return {
      tableData3: [],
      currentPage: 1,
      pageSize:10,
      pageData:[],
      up: {
        input1: '',
        inputDot: '',
        name: '',
        address: '',
        price: '0',
        priceValue: '0',
        decimals: 6,
        asset: BigNumber.from(0),
        origin: BigNumber.from(0)
      },
      token2: "",
      loading: false,
      dialogVisible: false,
      inputType: 0,
      num: "",
      inputDialog: false,
      priceRate: "0",
      canTransOut: "0",
      shareAsset: "",
      totalShare: "",
      optionAddress: "",
      showRevert: false,
      selectItem: null,
      showDrawer:false,
      showCancel:false
    }
  },
  created() {
    // this.init()
  },

  methods: {
    transBig2number,
    prevClick(e) {
      console.log(e)
      this.currentPage--
      this.getData()
    },
    setPage(val){
      let start=(val - 1) * this.pageSize;
      this.pageData=this.tableData3.slice(start,start+this.pageSize)
    },
    nextClick() {
      this.currentPage++
      this.getData()
    },
    async revert(row) {
      this.selectItem = row;
      if(isMobile()){
        this.showCancel=true;
      }else{
        this.showRevert = true;
      }
    },
    async doRevert() {
      if (!this.selectItem) {
        this.$message.error(this.$t('select_data'));
        this.showRevert = false;
        return;
      }
      await createLeadingContractAndSend(this.contractAddress, Method.handleWithdrawItems, [[this.selectItem.order], true, [], []])
      this.showRevert = false;
      emmitMessage({msg:MESSAGE.WITHDRAWAL,delay:2000})
      this.init()
    },
    getStatus(status){
      switch (status){
        case "1":
          return this.$t('pending_withdrawal');
        case "2":
          return this.$t("completed");
        case "3":
          return this.$t('cancel');
        case "4":
          return this.$t("applying");
      }
    },

    async getData() {
      if (!this.contractAddress) {
        return;
      }
      let tokenInfo = await getSelectTokenInfo(this.token);
      if (!tokenInfo) {
        return;
      }
      this.optionAddress = tokenInfo.perpetual;
      let account = await getAccount();
      let data = await getTransData(account, this.contractAddress, this.currentPage);
      data = data.transformTokens;

      let selectToken = await getSelectTokenInfo(this.token);

      // this.tableData3=[];
      let tableData = [];
      for (let i in data) {
        let item = data[i];
        tableData.push({
          order: item.orderId.toString(),
          coin: selectToken.symbol,
          type: item.isDeposit ? 0 : 1,
          price2: parseFloat(transBig2number(item.amount, 18, 2)),
          share: parseFloat(transBig2number(item.share, 18, 2)),
          nextTime: transTime2Date(parseInt(item.time)),
          showOperate: false,
          oTime: parseInt(item.time.toString()),
          state:this.getStatus(item.status)
        })
      }

      let leadData = await createLeadingContractAndCall(this.contractAddress, Method.getWithdrawItems, this.contractAddress)


      for (let i in leadData) {
        let item = leadData[i];
        if (item.user.toLowerCase() !== account.toLowerCase()) {
          continue;
        }
        tableData.push({
          order: item.withdrawID.toString(),
          coin: selectToken.symbol,
          type: 1,
          price2: parseFloat(transBig2number(item.withdrawAmount, 18, 2)),
          share: parseFloat(transBig2number(item.withdrawShare, 18, 2)),
          nextTime: transTime2Date(parseInt(item.withdrawTime)),
          showOperate: true,
          oTime: parseInt(item.withdrawTime.toString()),
          state:this.getStatus("4")
        })
      }

      tableData = tableData.sort((e1, e2) => {
        return e2.oTime - e1.oTime;
      })


      this.tableData3 = tableData;
      this.currentPage=1;
      this.setPage(1)
    },
    async initData() {
      this.up.input1 = this.token
      this.up.inputDot = getDotAddress(this.token);
      this.up.address = await getAccountWithDot()
      let account = await getAccount()
      let tokenInfo = await getErc20Info([this.token])
      this.up.name = tokenInfo[0]
      let balance = await getErc20Info([this.token], Method.balanceOf, [account], -1)
      let decimals = await getErc20Info([this.token], Method.decimals)
      this.up.price = transBig2number(balance, parseInt(decimals[0].toString()))

      this.up.decimals = parseInt(decimals[0]);

      let asset = await createLeadingContractAndCall(this.contractAddress, Method.userShares, account);

      this.up.asset = asset
      this.up.origin = asset;

      let price = await getLastPrice()
      let priceBTC = transBig2number(price[Underling.BTC].price, price[Underling.BTC].decimal, 6);
      let priceETH = transBig2number(price[Underling.ETH].price, price[Underling.ETH].decimal, 6);

      let priceBtcNum = transNumber2Big(priceBTC);
      let priceEthNum = transNumber2Big(priceETH);

      let asset2 = await createLeadingContractAndCall(this.contractAddress, Method.getTotalBalance, [Underling.BTC, Underling.ETH], [priceBtcNum, priceEthNum]);
      asset2 = asset2.assetAmount ?? "0";

      this.shareAsset = asset2

      let totalShare = await createLeadingContractAndCall(this.contractAddress, Method.totalShare);
      totalShare = totalShare ?? 0;

      this.totalShare = totalShare;
      if(totalShare.gt(BigNumber.from(0))){
        let shareValue = asset2.mul(BigNumber.from(100000000)).div(totalShare)

        this.up.priceValue = transBig2number(shareValue.mul(asset).div(BigNumber.from(100000000)));
        this.priceRate = (parseFloat(shareValue.toString()) / 100000000);
      }


    },
    async deposit() {
      this.$store.commit('setLoading', true)
      if (this.num <= 0) {
        this.$store.commit('setLoading', false)
        await this.$message.warning(this.$t("deposit_parameter_invalid"));
        return;
      }
      let inputAmount = BigNumber.from(transNumber2Big(this.num, this.up.decimals));
      let address = await getAccount();
      let chainId = await getChainId();

      let balance = await getErc20Info([this.token], Method.balanceOf, [address], -1);
      if (inputAmount.gt(balance[0])) {
        this.$store.commit('setLoading', false)
        await this.$message.error(this.$t("insufficient_balance"));
        return;
      }

      let allowance = await getErc20Info([this.token], Method.allowance, [address, this.contractAddress], -1);
      allowance = allowance[0];
      if (inputAmount.gt(allowance)) {
        await createErc20AndSend(this.token, Method.approve, [this.contractAddress, ethers.constants.MaxUint256.toString()]);
        await sleep(2000);
      }

      let inputAmount2=transNumber2Big(this.num, 18);

      let price = await getLastPrice();
      // let tigger=await getGasReward(this.token,Underling.ETH);
      let res = await createLeadingContractAndSend(this.contractAddress, Method.deposit, [inputAmount2, [Underling.BTC, Underling.ETH], [ethers.utils.arrayify(price[Underling.BTC].hex), ethers.utils.arrayify(price[Underling.ETH].hex)]], config[chainId].verifyValue)
      await this.initData();
      this.$store.commit('setLoading', false)
      emmitMessage({msg:MESSAGE.DEPOSIT,delay:2000})
      this.$emit("refresh-data");
    },
    async withdrawal() {
      this.$store.commit('setLoading', true)
      if (this.num <= 0) {
        await this.$message.warning(this.$t("deposit_parameter_invalid"));
        this.$store.commit('setLoading', false)
        return;
      }
      // let account=await getAccount()
      // let asset= await createLeadingContractAndCall(this.contractAddress,Method.userShares,account);
      // let assetNum=parseFloat(transBig2number(asset,this.up.decimals));
      if (BigNumber.from(transNumber2Big(this.num)).gt(this.up.asset) && !isOld()) {
        await this.$message.warning(this.$t('withdrawalExceedsMaxBalance'));
        this.$store.commit('setLoading', false)
        return;
      }

      let inputAmount = transNumber2Big(this.num, 18);
      let res = await createLeadingContractAndSend(this.contractAddress, Method.withdraw, [inputAmount.toString()], 0)
      await this.initData()
      this.$store.commit('setLoading', false)
      emmitMessage({msg:MESSAGE.WITHDRAWAL,delay:2000})
      this.$emit("refresh-data");
    },
    async init() {
      this.loading = true;
      await this.initData();
      await this.getData();
      this.loading = false;
    },
    ok1() {
      if (this.inputType == 0) {
        this.deposit()
      } else {
        this.withdrawal()
      }
      this.dialogVisible = false;
    },
    async showDialog(type) {
      this.num=""
      this.inputType = type;
      if(isMobile()){
        this.showDrawer=true;
      }else{
        this.inputDialog = true;
      }

    },
    ok2() {
      this.inputDialog = false;
      this.showDrawer=false;
      this.dialogVisible = true;
    },
    max() {
      if (this.inputType == 0) {
        this.num = this.up.price;
      } else {
        this.num = transBig2number(this.up.asset,18,18,true);
      }
    }
  },
  watch: {
    num(val) {
      if (val < 0) {
        this.num = 0;
      }
      if (!val) {
        this.canTransOut = "0";
      } else {
        this.canTransOut = (parseFloat(val) * parseFloat(this.priceRate)).toFixed(2);
      }
    },
    currentPage(val){
      this.setPage(val)
    }
  },
}
</script>

<style src="../assets/list.scss" lang="scss" scoped></style>
<style src="../assets/css/index.scss" lang="scss" scoped></style>
<style src="../assets/windows.scss" lang="scss" scoped></style>

<style lang="scss" scoped>
.out_box {
  color: #A6A6A6;
  font-weight: 500;

  span {
    color: #ffffff;
  }
}

.el-input__inner {
  padding: 0px !important;
  width: 180px !important;
}

.left {
  flex: revert;
}

::v-deep .el-dialog__title {
  font-weight: 400 !important;
  font-size: 18px;
  letter-spacing: 0px;
  line-height: 21.1px;
  color: rgba(234, 236, 239, 1);
}

::v-deep .el-dialog__footer {
  display: flex !important;
  width: 100% !important;
  padding-top: 0px;
  padding-bottom: 20px;

  .el-button {
    flex: 1;
    width: calc(100% - 10px);
  }
}

.open-amount-container {
  display: flex;
  height: 40px;
  opacity: 1;
  border-radius: 6px;
  background: #181A20;
  align-items: center;
  border: 1px solid #EAECEF33;
  font-size: 12px;
  padding-right: 13px;

  .open-amount-input {
    border: none;
    padding: 8px;
    color: #EAECEF;
    background-color: transparent;
    outline: none;
    flex: 1;
  }
}

.info-list {
  flex: revert !important;
  margin-right: 95px !important;
}

.btc-label {
  color: #EAECEF;
  margin-left: 5px;
  flex: 0 0 auto;
  cursor: pointer;
}

::v-deep .el-dialog {
  width: 380px !important;
}

.mobile_table_box {
  display: none;
}

.asset_content {
  margin-left: 15px;
  margin-right: 15px;
  padding: 17px 20px 17px 20px;
  border: 0.55px solid rgba(56, 56, 56, 1);
  border-radius: 6px;
  .asset_box {

    .content{
      display: flex;
      justify-content: space-between;
      .title{
        font-size: 13px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 15.24px;
        color: rgba(90, 90, 93, 1);
      }
      .value{
        font-size: 13px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 15.24px;
        color: rgba(255, 255, 255, 1);
        margin-top: 4px;
      }
      .right{
        text-align: right;
      }
    }
  }
}

@media (max-width: 750px) {
  ::v-deep .el-dialog {
    width: 80% !important;
  }
  .mobile_table_box {
    display: block;
  }
  .mobile_content_c{
    margin-bottom: 20px;
    min-height: 100px;
  }
  .operate_box{
    justify-content: right !important;
  }
  .info {
    display: flex;
    justify-content: space-between;

    .title {
      font-size: 13px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 15.24px;
      color: rgba(90, 90, 93, 1);
    }

    .value {
      font-size: 13px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 15.24px;
      color: rgba(255, 255, 255, 1);
    }

    .left {
      text-align: left;
    }

    .right {
      text-align: right;
    }
  }
  .mobile_table_box {

    .item {
      display: grid;
      grid-template-columns: repeat(3, 1fr); /* 3 列，等宽分配 */
      grid-template-rows: repeat(2, 1fr); /* 2 行，等高分配 */
      margin-top: 20px;
      border-bottom: 0.2px solid rgba(90, 90, 93, 1);
      padding-bottom: 25px;
      padding-left: 25px;
      padding-right: 25px;
      row-gap: 18px;

      .title {
        font-size: 11px;
        font-weight: 500;
        letter-spacing: -1px;
        line-height: 15.93px;
        color: rgba(90, 90, 93, 1);
      }

      .value {
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 14.06px;
        color: rgba(234, 236, 239, 1);
        margin-top: 6px;
      }

      .right {
        text-align: right;
      }

      .middle {
        text-align: center;
      }
      .cancel{
        color: rgba(165, 214, 63, 1);
      }
    }
  }
}

.drawer {

  background: rgba(19, 20, 21, 1);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-bottom: 60px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 8px;

  .minus {
    margin: auto;
    margin-bottom: 10px;
    width: 40px;
    height: 4px;
    border-radius: 2px;
    background: rgba(128, 128, 128, 1);
  }

  .title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;

    .title_c {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0px;
      line-height: 18.75px;
      color: rgba(255, 255, 255, 1);
    }

    .title_i {
      width: 16px;
      height: 16px;
    }

  }

  .item {
    margin-top: 14px;
    box-sizing: border-box
  }

  .el-drawer {
    background: transparent !important;
  }
  .open-amount-container{
    background: rgba(37, 40, 44, 1);
    border: none;
  }
}
::v-deep .el-drawer{
  background: transparent !important;
}

</style>
<style>
.el-table, .el-table__expanded-cell {
  background-color: rgba(24, 26, 32, 1);
}

.el-button--primary {
  border-color: rgb(198, 254, 97) !important;
}
</style>
<style src="../assets/css/mobile.scss" lang="scss" scoped></style>
